'use client'

import { ReactElement, ReactNode, createContext, useCallback, useState } from 'react'
import { v4 } from 'uuid'

export interface Modal{
  createModal: (modal: ReactNode) => void;
  destroyModal: () => void;
}

export const ModalContext = createContext<Modal | null>(null)

export function ModalProvider({ children }: {
  children: ReactNode;
}): ReactElement {
  const [modals, setModals] = useState<ReactNode[]>([])

  const addModal = useCallback((modal: ReactNode) => {
    setModals([
      <div key={v4()}>{modal}</div>,
    ])
  }, [])

  const destroyModal = useCallback(() => {
    setModals(modals.slice(0, -1))
  }, [modals])

  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <ModalContext.Provider value={{
      createModal: addModal,
      destroyModal,
    }}
    >
      {modals}
      {children}
    </ModalContext.Provider>
  )
}
